import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import { CloseIcon } from '../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0.125rem 0.625rem 0.063rem 0.625rem',
    borderRadius: '0.5rem',
    backgroundColor: theme.palette.status.purple,
    display: 'flex',
    alignItems: 'center',
    height: '2.5rem',
  },
  text: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    letterSpacing: '0',
    color: theme.palette.font.white,
    fontWeight: '500',
    height: '2.313rem',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    fontSize: '0.938rem',
    color: theme.palette.font.white,
    opacity: '0.6',
  },
  iconBtn: {
    padding: '0.25rem 0.188rem 0.188rem 0.25rem',
    marginLeft: '1rem',
  },
}));

export default function Tag({ tag, onRemove, style, id }) {
  const classes = useStyles();
  return (
    <div className={classes.root} style={style}>
      <div className={classes.text}>{tag.tag}</div>
      <IconButton id={id} className={classes.iconBtn} onClick={onRemove}>
        <CloseIcon className={classes.icon} />
      </IconButton>
    </div>
  );
}
